var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row schedule-area"},[(_vm.label)?_c('label',{staticClass:"sm-text",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('Button',{class:'schedule-button',attrs:{"label":_vm.buttonLabel + _vm.value},on:{"action":function($event){return _vm.updateInput(_vm.value)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }